// import Layout from "../../../components/Layout";
import PageTitle from "../../../components/PageTitle";
import Tab from "@mui/material/Tab";
import { useEffect, useState } from "react";
import TabPanel from "@mui/lab/TabPanel";
import Tabs from "@mui/lab/TabList";
import TabContext from "@mui/lab/TabContext";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import Table from "../../../components/Table/Table";
import { TableSearch } from "../../../components/Table/TableActions";
import { useNavigate, Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import Button from "../../../components/Button";
import Modal from "../../../components/Modal";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import Badge from "../../../components/Badge";
import useWindowSize from "../../../hooks/useWindow";
import PopModal from "../../../components/PopupModal/PopModal";
import useStyles from "../styles";
import { Grid } from "@mui/material";
import InputGroup from "../../../components/FormComponent/InputGroup";

// GET ALL ASSIGNMENT BY CLASS
const GET_ALL_ASSIGNMENT = "/api/v1/assignment";
const ASSIGNMENT_BY_CLASS_ENDPOINT = "/api/v1/assignment-configs";
const ASSIGNMENT_CONFIG_ENDPOINT = "/api/v1/assignment-configs";
const CLASSES_ENDPOINT = "/api/v1/class";
const OBTAINABLE_SCORE = "/api/v1/obtainable-score";
const SESSION_ENDPOINT = "/api/v1/school-plan/session";

const Assignment = () => {
  const [value, setValue] = useState("1");
  const classes = useStyles();
  const [assignmentsdata, setAssignmentsData] = useState([]);
  const [assignmentbyclass, setAssignmentByClass] = useState([]);
  const [searchResult, setSearchResult] = useState([]);
  const [classesData, setClassData] = useState([]);
  const [obtainablescore, setObtainableScore] = useState([]);
  const [sessionData, setSessionData] = useState([]);
  const [assignmentresultbyclass, setAssignmentResultByClass] = useState([]);
  const [isPageFetching, setIsPageFetching] = useState(false);
  const [filterStatus, setFilterStatus] = useState("");
  const [currentRow, setCurrentRow] = useState({});
  const [preserveQuestionsInBank, setPreserveQuestionsInBank] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isDeleting, setisDeleting] = useState(false);
  const [isConverting, setIsConverting] = useState(false);
  const [convertModal, setConvertModal] = useState(false);
  const navigate = useNavigate();
  const [convertForm, setConvertForm] = useState({
    is_ca: true,
    ca_type: ""
  });

  /**
 * Fetches all assignments grouped by class and sets the state.
 */
  const getAllAssignmentByClass = () => {
    httprequest.get(ASSIGNMENT_BY_CLASS_ENDPOINT).then((res) => {
      setAssignmentsData(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  /**
 * Handles form field changes for the convert modal.
 * @param {React.ChangeEvent<HTMLInputElement | HTMLSelectElement>} e
 */
  const handleConvertChange = (e) => {
    const { name, value } = e.target;
    setConvertForm({ ...convertForm, [name]: value });
  };

  const width = useWindowSize();
  const mobile = width < 600;
  const preserveCheckboxStatus = String(currentRow?.status ?? "").trim().toLowerCase();
  const shouldShowPreserveQuestionsCheckbox = preserveCheckboxStatus !== "" && preserveCheckboxStatus !== "empty";

  /**
 * Closes the delete modal.
 */
  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setPreserveQuestionsInBank(false);
  };

  /**
 * Opens or closes the convert-to-test modal and sets the current row.
 * @param {Object} row - Assignment row data
 */
  const handleConvertModal = (row) => {
    setCurrentRow(row);
    setConvertModal(!convertModal);
  };

  /**
 * Closes the convert-to-test modal.
 */
  const handleCloseConvertModal = () => {
    setConvertModal(false);
    // setConvertForm({ ...convertForm, ca_type: "", is_ca: "" });
  };

  /**
 * Opens or closes the delete confirmation modal and sets the current row.
 * @param {Object} row - Assignment row data
 */
  const handleDeleteModal = (row) => {
    setCurrentRow(row);
    setPreserveQuestionsInBank(false);
    setDeleteModal(!deleteModal);
  };

  /**
 * Fetches all physical classes and sets the state.
 */
  const getAllClasses = () => {
    httprequest.get(CLASSES_ENDPOINT).then((res) => {
      const physicalClasses = res?.data?.data?.filter((data) => data?.class_type === "physical");
      setClassData(physicalClasses);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  /**
 * Filters assignment data (all) based on the selected status.
 * @param {React.ChangeEvent<HTMLInputElement} e
 */
  const handleFilterChange = (e) => {
    const { value } = e.target;
    setFilterStatus(value);

    // Filter assignments based on selected status
    const filteredByStatus = value === "published"
      ? assignmentsdata?.filter((data) => data?.status === "published")
      : value === "draft"
        ? assignmentsdata?.filter((data) => data?.status === "draft")
        : value === "withdrawn"
          ? assignmentsdata?.filter((data) => data?.status === "withdrawn")
          : value === "scheduled"
            ? assignmentsdata?.filter((data) => data?.status === "scheduled")
            : value === "expired"
              ? assignmentsdata?.filter((data) => data?.status === "expired")
              : assignmentsdata;
    setSearchResult(filteredByStatus);
  };

  /**
 * Filters assignment data (by class) based on the selected status.
 * @param {React.ChangeEvent<HTMLInputElement | HTMLSelectElement>} e
 */
  const handleFilterClassChange = (e) => {
    const { value } = e.target;
    setFilterStatus(value);

    // Filter assignments based on selected status in a class
    const filteredByStatus = value === "published"
      ? assignmentresultbyclass?.filter((data) => data?.status === "published")
      : value === "draft"
        ? assignmentresultbyclass?.filter((data) => data?.status === "draft")
        : value === "withdrawn"
          ? assignmentresultbyclass?.filter((data) => data?.status === "withdrawn")
          : value === "scheduled"
            ? assignmentresultbyclass?.filter((data) => data?.status === "scheduled")
            : value === "expired"
              ? assignmentresultbyclass?.filter((data) => data?.status === "expired")
              : assignmentresultbyclass;

    setAssignmentByClass(filteredByStatus);
  };

  /**
 * Fetches assignment data by class using the selected class value.
 */
  const getAssignmentByClass = () => {
    setIsPageFetching(true);
    httprequest.get(`${ASSIGNMENT_BY_CLASS_ENDPOINT}?class_id=${value}`).then((res) => {
      setIsPageFetching(false);
      setAssignmentByClass(res?.data?.data);
      setAssignmentResultByClass(res?.data?.data);
    }).catch((err) => {
      setIsPageFetching(false);
      toast.error(err?.response?.data);
    });
  };

  /**
 * Fetches all assignment data and sets both assignments and search results.
 */
  const getAllAssignment = () => {
    setIsPageFetching(true);
    httprequest.get(GET_ALL_ASSIGNMENT).then((res) => {
      setIsPageFetching(false);
      setAssignmentsData(res?.data?.data);
      setSearchResult(res?.data?.data);
    }).catch((err) => {
      setIsPageFetching(false);
      toast.error(err?.response?.data);
    });
  };

  /**
 * Deletes the currently selected assignment.
 */
  const handleDeleteAssignment = () => {
    setisDeleting(true);
    httprequest
      .delete(`${ASSIGNMENT_CONFIG_ENDPOINT}/${currentRow?.id}`, {
        data: {
          preserve_questions_in_bank: !!preserveQuestionsInBank
        }
      })
      .then((res) => {
        setisDeleting(false);
        toast.success(res?.data?.message);
        handleCloseDeleteModal();
        getAllAssignment();
      })
      .catch((err) => {
        setisDeleting(false);
        toast.error(err?.response?.data?.message);
      });
  };

  /**
 * Converts an assignment to/from a CA (Continuous Assessment) or test.
 */
  const handleConvertToTest = () => {
    setIsConverting(true);

    const body = currentRow?.assignment?.is_ca ? { is_ca: false } : { is_ca: true, ca_type: convertForm.ca_type || "CA1" };
    httprequest
      .patch(`${GET_ALL_ASSIGNMENT}/${currentRow?.assignment?.id}/convert`, body)
      .then((res) => {
        setIsConverting(false);
        toast.success(res?.data?.message);
        handleCloseConvertModal();
        getAllAssignment();
      })
      .catch((err) => {
        setIsConverting(false);
        toast.error(err?.response?.data?.message);
      });
  };

  /**
   * Fetches all available academic sessions from the backend.
   * Updates the sessionData state with the fetched data.
   */
  const getAllSession = () => {
    httprequest
      .get(SESSION_ENDPOINT)
      .then((res) => {
        setSessionData(res?.data?.data?.find((active_session) => active_session?.current_session === true));
      })
      .catch(() => {});
  };

  /**
       * Fetches all obtainable scores from the API
       */
  const getAllObtainableScores = (sessionId) => {
    httprequest
      .get(OBTAINABLE_SCORE)
      .then((res) => {
        setObtainableScore(res?.data?.data?.find((obtainable) => obtainable?.session?.id === sessionId) || []);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  useEffect(() => {
    if (sessionData?.id) {
      getAllObtainableScores(sessionData.id);
    }
  }, [sessionData?.id]);

  const columns = [
    {
      name: "Subject",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Subject</p>}
          {row?.subject?.name || "--/--"}
        </>
      )
    },
    {
      name: "Class",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Class</p>}
          {row?.class?.name || "--/--"}
        </>
      )
    },
    {
      name: "Created By",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Created By</p>}
          {`${row?.created_by?.last_name || "--/--"} ${row?.created_by?.first_name || "--/--"}`}
        </>
      )
    },
    {
      name: "Date Updated",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Date Updated</p>}
          {row?.updated_at?.substring(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "Submission Date",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Submission Date</p>}
          {row?.submission_date?.substring(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "Status",
      center: true,
      cell: (row) => <Badge status={row.status} />
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => {
        const showConvertOrRevert = row?.status && row?.status !== "empty" && !!row?.assignment?.id;

        return (
          <div key={row?.id} className="table-action-container">
            {showConvertOrRevert && (
              row?.assignment?.is_ca ? (
                <button
                  onClick={() => handleConvertModal(row)}
                  className="table-action-icon"
                >
                  <Icon icon="basil:cancel-solid" width="22" height="22" style={{ color: "#850808" }} />
                </button>
              ) : (
                <button
                  onClick={() => handleConvertModal(row)}
                  className="table-action-icon"
                >
                  <Icon
                    icon="fluent:arrow-sort-20-regular"
                    width="20"
                    height="20"
                    style={{ transform: "rotate(30deg)" }}
                  />
                </button>
              )
            )}
            <Link to={`/assignments/${row?.id}`}>
              <button className="table-action-icon">
                <Icon icon="fluent:eye-16-regular" />
              </button>
            </Link>
            <button className="table-action-icon"
              onClick={() => navigate(`/assignments/${row?.id}?editConfig`)}
            >
              <Icon icon="heroicons:pencil-square-solid" />
            </button>
            <button
              onClick={() => handleDeleteModal(row)}
              className="table-action-icon delete-icon"
            >
              <Icon icon="mingcute:delete-2-line" />
            </button>
          </div>
        );
      }
    }
  ];

  useEffect(() => {
    getAllAssignmentByClass();
    getAllAssignment();
    getAllClasses();
    getAllSession();
  }, []);

  /**
 * Handles tab change in the assignment interface.
 * @param {Event} event
 * @param {string} newValue
 */
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  /**
 * Searches assignment-by-class data using subject, class, or creator's name.
 * @param {React.ChangeEvent<HTMLInputElement>} e
 */
  const handleSearchAssignmentByClass = (e) => {
    const { value } = e.target;
    const valArray = value.split(" ");

    const filteredByStatus = filterStatus
      ? assignmentresultbyclass.filter((data) => data.status.toLowerCase() === filterStatus.toLowerCase())
      : assignmentresultbyclass;

    // Filter by partial match in subject, class, and creator's name
    const result = filteredByStatus?.filter((data) => valArray?.every(
      (word) => data?.subject?.name?.toLowerCase().includes(word.toLowerCase()) ||
                data?.class?.name?.toLowerCase().includes(word.toLowerCase()) ||
                data?.created_by?.name?.toLowerCase().includes(word.toLowerCase())
    ));

    setAssignmentByClass(result);
  };

  /**
 * Searches all assignments using subject, class, or creator's name.
 * @param {React.ChangeEvent<HTMLInputElement>} e
 */
  const handleSearchAssignment = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    const filteredByStatus = filterStatus
      ? assignmentsdata.filter((data) => data.publish_date.toLowerCase() === filterStatus.toLowerCase())
      : assignmentsdata;
    // --| Filter data by partial match onchange in the search input box
    const result = filteredByStatus?.filter((data) => valArray?.every(
      (word) => data?.subject?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
            data?.class?.name?.toLowerCase()
              .includes(word.toLowerCase()) ||
            data?.created_by?.name?.toLowerCase()
              .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  useEffect(() => {
    if (value !== "1") {
      getAssignmentByClass();
    }
  }, [value]);

  return (
    <>
      <PageTitle
        title="See All Assignments"
        subtitle="See all assignment in my school"
        button={
          <div className="flex gap-10">
            <div className="flex gap-10">
              <PopModal title="Assignments" videoUrl="https://youtu.be/3VFd2635xy8" />

              <Button onClick={() => {
                navigate("/assignment/create-assignment");
              }} variant="primaryoutline" buttonSize="fluid" color="btnfontprimary" buttonName="Create Assignment"
              />
            </div>
          </div>
        }
      />
      <div className="page-content">
        <TabContext value={value}>
          {assignmentsdata.length > 0 && (
            <div className="tablist-container padding-left-16">
              <Tabs
                className="overide-tablist"
                onChange={handleChange}
                aria-label=""
              >
                <Tab label="All Assignments" value="1" />
                {classesData?.map((data, i) => {
                  return (
                    <Tab key={i} value={data?.id} label={data?.class_name} />
                  );
                })}
              </Tabs>
            </div>
          )}
          <TabPanel value="1" className="tabpanel-overide">
            <Table data={searchResult} columns={columns} subHeader={true} pagination
              subHeaderComponent={
                assignmentsdata?.length > 0 && (
                  <div className="action_div">
                    <TableSearch placeholder="Search here..." searchTableFunc={handleSearchAssignment} />
                    <div className="text-center gap-10 cursor-pointer">
                      {isPageFetching ? <Icon icon="svg-spinners:270-ring-with-bg" width="20" height="20" style={{ color: "#858585" }} />
                        : <Icon onClick={getAllAssignment} icon="hugeicons:reload" width="20" height="20" style={{ color: "#858585" }} />}
                      <div>
                        <SelectGroup
                          children={
                            <select name="type" onChange={handleFilterChange}>
                              <option value="">-- Sort By--</option>
                              <option value="published">Published</option>
                              <option value="draft">Draft</option>
                              <option value="withdrawn">Withdrawn</option>
                              <option value="scheduled">Scheduled</option>
                              <option value="expired">Expired</option>
                            </select>
                          }
                        />
                      </div>
                    </div>
                  </div>
                )
              }
            />
          </TabPanel>
          {classesData?.map((data, i) => {
            return (
              <TabPanel className="tabpanel-overide" key={i} value={data?.id}>
                <Table
                  data={assignmentbyclass}
                  columns={columns}
                  subHeader={true}
                  pagination
                  subHeaderComponent={
                    assignmentsdata?.length > 0 && (
                      <div className="action_div">
                        <TableSearch placeholder="Search here..." searchTableFunc={handleSearchAssignmentByClass} />
                        <div className="text-center gap-10 cursor-pointer">
                          {isPageFetching ? <Icon icon="svg-spinners:270-ring-with-bg" width="20" height="20" style={{ color: "#858585" }} />
                            : <Icon onClick={getAssignmentByClass} icon="hugeicons:reload" width="20" height="20" style={{ color: "#858585" }} />}
                          <div>
                            <SelectGroup
                              children={
                                <select name="type" onChange={handleFilterClassChange}>
                                  <option value="">-- Sort By--</option>
                                  <option value="published">Published</option>
                                  <option value="draft">Draft</option>
                                  <option value="withdrawn">Withdrawn</option>
                                  <option value="scheduled">Scheduled</option>
                                  <option value="expired">Expired</option>
                                </select>
                              }
                            />
                          </div>
                        </div>
                      </div>
                    )}
                />
              </TabPanel>
            );
          })}

        </TabContext>
      </div>
      {/* Convert Modal */}
      <Modal
        title={currentRow?.assignment?.is_ca ? "Revert from CA" : "Convert To CA Test"}
        subtitle={
          <div>
            {currentRow?.assignment?.is_ca ? "Revert this assignment from CA (Continuous Assessment)." : "Convert Assignment To CA Test"}
          </div>
        }
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup
                  label="Subject"
                  margin="normal"
                  inputType="text"
                  required
                  defaultValue={currentRow?.subject?.name}
                  disabled
                  inputName="subject"
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup
                  label="Class"
                  margin="normal"
                  inputType="text"
                  required
                  disabled
                  inputName="class_id"
                  defaultValue={currentRow?.class?.name}
                />
              </Grid>
              <Grid item lg={6} md={12} sm={12} xs={12}>
                <InputGroup
                  label="Assignment Title"
                  margin="normal"
                  inputType="text"
                  required
                  inputName="examination"
                  defaultValue={currentRow?.title}
                  disabled
                />
              </Grid>
              <Grid item lg={6} md={12} sm={12} xs={12}>
                <InputGroup
                  label="Date Updated"
                  margin="normal"
                  inputType="text"
                  required
                  inputName="date_updated"
                  defaultValue={currentRow?.updated_at?.substring(0, 10)}
                  disabled
                />
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <SelectGroup
                  label="CA Type"
                  required
                  children={
                    <select defaultValue={currentRow?.assignment?.ca_type ?? ""} name="ca_type" onChange={handleConvertChange} disabled={!!currentRow?.assignment?.is_ca}>
                      <option value="">--- Select CA Type ---</option>
                      {obtainablescore?.ca?.map((ca, index) => {
                        return (
                          <option key={index} value={ca?.ca_type}>
                            {ca?.ca_type}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
              </Grid>
            </Grid>
          </>
        }
        modalFooter={
          <>
            <div className={classes.modalFooterBtn}>
              <Button
                variant="primaryoutline"
                buttonSize="full"
                color="btnfontprimary"
                buttonName="Cancel"
                onClick={handleConvertModal}
                //   isLoading={resultCreating}
              />
              <Button
                variant="primary"
                buttonSize="full"
                color="btndefault"
                buttonName={currentRow?.assignment?.is_ca ? "Revert" : "Convert To CA"}
                isLoading={isConverting}
                onClick={handleConvertToTest}
              />
            </div>
          </>
        }
        isopen={convertModal}
        closeModal={handleCloseConvertModal}
      />
      {/* Delete Modal */}
      <Modal
        title="Delete Assignment"
        subtitle={
          <div>
            Are you sure you want to remove{" "}
            <span className="modal-name-highlight">
              {currentRow?.title}
            </span>{" "}
            from one of your Assignment? Removing it will permanently
            clear this Assignment.
          </div>
        }
        modalContent={shouldShowPreserveQuestionsCheckbox ? (
          <div style={{ marginTop: 8 }}>
            <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={preserveQuestionsInBank}
                onChange={(e) => setPreserveQuestionsInBank(e.target.checked)}
              />
              Preserve questions on this Assignment and add them to bank.
            </label>
          </div>
        ) : <></>}
        modalFooter={
          <>
            <div className="flex gap-10">
              {/* <Button
                variant="dangeroutline"
                buttonSize="full"
                color="btndanger"
                buttonName="Cancel"
                onClick={handleCloseDeleteModal}
              /> */}
              <Button
                variant="danger"
                buttonName="Delete Assignment"
                buttonSize="full"
                color="btndefault"
                onClick={handleDeleteAssignment}
                isLoading={isDeleting}
              />
            </div>
          </>
        }
        isopen={deleteModal}
        closeModal={handleCloseDeleteModal}
      />
      {/* <ToastContainer /> */}
    </>
  );
};

export default Assignment;
